import { render, staticRenderFns } from "./Login-page.vue?vue&type=template&id=d0620d1e"
import script from "./Login-page.vue?vue&type=script&lang=js"
export * from "./Login-page.vue?vue&type=script&lang=js"
import style0 from "./Login-page.vue?vue&type=style&index=0&id=d0620d1e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports